/** Avatares de la mascota (doctor / doctora). D = de frente, L = mira a la izquierda, R = señala. */
export const AVATARES = {
  doctor: '/img/avatares/DR-D.png',
  doctorIzq: '/img/avatares/DR-L.png',
  doctorSenala: '/img/avatares/DR-R.png',
  doctora: '/img/avatares/DRA-D.png',
  doctoraIzq: '/img/avatares/DRA-L.png',
  doctoraSenala: '/img/avatares/DRA-R.png',
} as const;
